<template>
  <v-row no-gutters>
    <v-col cols="12" class="pa-0">
      <v-autocomplete
        hide-details
        multiple
        dense
        outlined
        color="primary"
        item-text="name"
        item-value="id"
        :items="vehicleGroups"
        :label="labels.chooseGroups"
        @change="filterVehicleTable"
        v-model="selectedVehicleGroups"
      >
        <template v-slot:prepend-item>
          <v-list-item ripple @click="toggleGroups">
            <v-list-item-action>
              <v-icon
                :color="selectedVehicleGroups.length > 0 ? 'indigo darken-4' : ''"
              >{{ groupIcon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ labels.selectAll }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import { getAllGroups } from '@/api/vehicleGroups.api'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'RealTimeMapVehicleAndVehicleGroupsFilter',
  data() {
    return {
      selectedVehicleGroups: [],
      vehicleGroups: [],
      labels: {
        chooseGroups: translate('Choose groups', 'mapFilters'),
        selectAll: translate('Select All', 'fields')
      },
      showVehicleGroupFilter: false,
    }
  },
  mounted() {
    getAllGroups().then(response => {
      this.vehicleGroups = response.data
    })
  },
  computed: {
    groupIcon() {
      if (this.groupsSelectedAll) return 'mdi-close-box'
      if (this.someGroupsSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    groupsSelectedAll() {
      return this.selectedVehicleGroups.length === this.vehicleGroups.length
    },
    someGroupsSelected() {
      return this.selectedVehicleGroups.length > 0 && !this.groupsSelectedAll
    },
    ...mapGetters('filters', ['getFilterFunction']),
    ...mapState('map', ['vehicles', 'realTimeRoutes']),
  },
  methods: {
    filterVehicleTable() {
      store.dispatch('filters/setVehicleGroups', this.selectedVehicleGroups)
      this.getFilterFunction.forEach(fnc => {
        fnc(this.vehicles, this.realTimeRoutes)
      })
    },
    toggleGroups() {
      if (this.groupsSelectedAll) {
        this.selectedVehicleGroups = []
      } else {
        this.selectedVehicleGroups = this.vehicleGroups.map(x => x.id)
      }
      this.filterVehicleTable()
    }
  }
}
</script>
